import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "@reach/router";
import classNames from "classnames";
import Logo from "../elements/Logo";
import { AppContext } from "~/scripts/context/app";

const NavLink = props => {
    const handleProps = ({ isCurrent }) => ({
        className: classNames(props.className, { "is-active": isCurrent })
    });

    return (
        <Link {...props} getProps={handleProps}>
            {props.children}
        </Link>
    );
};

NavLink.propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string)
    ])
};

class Nav extends Component {
    static contextType = AppContext;

    prevSt = null;

    state = {
        revealed: false,
        innerRevealed: false
    };

    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);
        this.handleScroll();
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    }

    handleScroll = () => {
        const st = window.pageYOffset;

        if (st > this.prevSt && st > 100) {
            this.hide();
        } else {
            this.reveal();
        }

        this.prevSt = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    };

    reveal = () => {
        if (this.state.revealed) return;
        this.setState({
            revealed: true
        });
    };

    hide = () => {
        if (!this.state.revealed) return;
        this.setState({
            revealed: false
        });
    };

    render() {
        const { theme } = this.context;
        const { revealed } = this.state;

        return (
            <nav
                className={classNames(
                    "nav",
                    `theme-${theme}`,
                    `${revealed ? "is-nav-revealed" : ""}` //is-nav-revealed
                )}
            >
                <div className="nav__inner">
                    <div className={classNames("nav__items")}>
                        <NavLink className="nav__link" to="/">
                            Directors
                        </NavLink>
                        <NavLink className="nav__link" to="/line-production">
                            Line Production
                        </NavLink>
                        <NavLink className="nav__link" to="/about">
                            About
                        </NavLink>
                    </div>
                    <Link className="nav__logo" to="/" aria-label="Home">
                        <Logo />
                    </Link>
                </div>
            </nav>
        );
    }
}

export default Nav;



// WEBPACK FOOTER //
// ./src/scripts/components/Nav.js